import request from 'src/network';

const apiPath = '/api/v1/generate_content';

export function marketingAgentgetIdService(question:string) {
    return request.POST<{ id: number }>(apiPath, { question });
}

export function marketingAgentQuestionService(id: number) {
    return request.GET<{ result: string }>(`${apiPath}/${id}`);
}